module.exports = __webpack_public_path__ + "img/表1-1图纸的基本幅面及尺寸.e45339c7.png";